"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./ScrollInPlace.scss");
var _LottieAnimation = _interopRequireDefault(require("../LottieAnimation/LottieAnimation"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const ScrollInPlace = _ref => {
  let {
    TitleContent,
    titleBackground,
    slides,
    a11yMode
  } = _ref;
  let hasScript = false;
  let sets = null;
  const [isA11yMode, updateIsA11yMode] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    updateIsA11yMode(a11yMode);
    if (document !== undefined) {
      if (document?.body?.classList.contains("has-scroll-in-place")) {
        hasScript = true;
      } else {
        document?.body?.classList.add("has-scroll-in-place");
      }
    }
    sets = document.getElementsByClassName("scroll-in-place-container");
  }, [a11yMode]);
  let currentHooked = null;
  let currentSlide = null;
  let currentOffset = 0;
  let lastTouchPos = null;
  let pauseSlideToggle = false;
  let lastWheel = Date.now();

  // this is the amount a user needs to scroll before a slide changes
  const desktopSlideScrollBuffer = 8;
  const mobileSlideScrollBuffer = 24;
  let slideScrollBuffer = desktopSlideScrollBuffer;
  function pauseSlides() {
    // stop the slides from moving, usually fired after the change of slide
    pauseSlideToggle = true;
    setTimeout(function () {
      pauseSlideToggle = false;
    }, 500);
  }
  function updateNavButtons(buttonClicked) {
    currentHooked?.element?.getElementsByClassName("progress-nav")?.[0]?.getElementsByClassName("btn-active")?.[0]?.classList?.remove("btn-active");
    currentHooked?.element?.getElementsByClassName("slide-jump-nav")?.[0]?.getElementsByClassName("btn-active")?.[0]?.classList?.remove("btn-active");
    buttonClicked?.classList?.add("btn-active");
    const clickedIndex = buttonClicked?.dataset?.slideIndex;
    if (buttonClicked?.dataset?.buttonType === "progress-nav") {
      currentHooked?.element?.getElementsByClassName("slide-jump-nav")?.[0]?.querySelector(`[data-slide-index="${clickedIndex}"]`)?.classList?.add("btn-active");
    } else if (buttonClicked?.dataset?.buttonType === "slide-jump-nav") {
      currentHooked?.element?.getElementsByClassName("progress-nav")?.[0]?.querySelector(`[data-slide-index="${clickedIndex}"]`)?.classList?.add("btn-active");
    }
  }
  (0, _react.useEffect)(() => {
    // hook up the slide set navigation buttons
    for (let i = 0; i < sets?.length; i++) {
      const navButtons = sets[i].getElementsByClassName("nav-btn");
      for (let j = 0; j < navButtons.length; j++) {
        navButtons[j].addEventListener('click', function (e) {
          if (currentHooked) {
            const buttonIndex = e?.target?.dataset?.slideIndex;
            const matchingSlide = currentHooked?.element?.querySelector(`[data-slide-index="${buttonIndex}"]`);
            currentSlide?.classList?.remove("active");
            matchingSlide?.classList?.add("active");
            currentSlide = matchingSlide;
            //update the nav button active states
            updateNavButtons(e?.target);
          }
        });
      }
    }
  }, [TitleContent, titleBackground, slides]);
  (0, _react.useEffect)(() => {
    if (document !== undefined && window !== undefined && !hasScript) {
      function getCorrespondingNavButton(slideIndex) {
        return currentHooked?.element?.getElementsByClassName("progress-nav")?.[0]?.querySelector(`[data-slide-index="${slideIndex}"]`);
      }

      // listen to hook a slide set into full screen
      window.addEventListener('scroll', function () {
        if (!currentHooked) {
          const slideSetPositions = [];

          // loop through all slide sets on a page and build array of their dom elements and positions
          for (let i = 0; i < sets?.length; i++) {
            const setRect = sets[i].getBoundingClientRect();
            slideSetPositions.push({
              element: sets[i],
              position: setRect.top,
              bottom: setRect.bottom,
              finished: sets?.[i]?.classList?.contains("activated") && !sets?.[i]?.classList?.contains("active") ? true : false,
              slides: sets[i].getElementsByClassName("slide")
            });
          }
          for (let i = 0; i < slideSetPositions.length; i++) {
            // If entering the slideset from the top
            const current = slideSetPositions[i];
            if (current?.position <= 0 && !current?.finished && current?.element !== currentHooked?.element) {
              currentSlide = null;
              currentOffset = 0;
              currentHooked = current;
              document.body.style.overflow = "hidden";
              currentHooked.element.classList.add("active");
              currentHooked.element.classList.add("activated");
              pauseSlides();
            } else if (current?.bottom >= window.innerHeight && current?.finished && current?.element !== currentHooked?.element && current?.slides?.[current?.slides?.length - 1]?.classList?.contains("active")) {
              // If entering the slideset from the bottom
              currentSlide = null;
              currentHooked = current;
              document.body.style.overflow = "hidden";
              currentHooked.element.classList.add("active");
            } else if (current.element.classList.contains("activated") && current.element.getBoundingClientRect().top > 5) {
              // If exited the slide set and continueing to scroll up
              current.element.classList.remove("activated");
              current.finished = false;
            }
          }
        }
      });

      // listen to scroll through a hooked slide set
      function changeScrollCalibrations(sb) {
        slideScrollBuffer = sb;
      }
      document.addEventListener('touchstart', function () {
        changeScrollCalibrations(mobileSlideScrollBuffer);
      });
      document.addEventListener('touchend', function () {
        changeScrollCalibrations(desktopSlideScrollBuffer);
      });
      document.addEventListener('touchcancel', function () {
        changeScrollCalibrations(desktopSlideScrollBuffer);
      });
      document.addEventListener('touchmove', function (e) {
        // listen for a touch event and create a 'fake' scroll event to scroll slides
        pauseSlideToggle = false;
        const currentTouchPos = e?.touches?.[0]?.clientY;
        const wheelEvt = new Event('wheel');
        if (currentTouchPos > lastTouchPos) {
          wheelEvt.deltaY = -150;
        } else if (currentTouchPos < lastTouchPos) {
          wheelEvt.deltaY = +150;
        }
        window.dispatchEvent(wheelEvt);
        lastTouchPos = currentTouchPos;
      });
      document.addEventListener('click', function (e) {
        // if the user clicks on a button within the SiP, remove the scroll lock on the body
        if (e.target.classList.contains("ter-button")) {
          document.body.style.overflow = "visible";
          document.body.classList.remove("has-scroll-in-place");
        }
      });
      window.addEventListener('wheel', function (e) {
        const currentWheel = Date.now();
        if (currentHooked && !pauseSlideToggle) {
          // get the scroll delta (pixel amount), taken from physical scroll wheel scroll or synthetic value from mobile touchmove event 
          // (val > 0 -> scroll down ||  val < 0 -> || scroll up)
          const scrollDelta = e.deltaY;

          // determine the current slide if unset, otherwise, determine the current slide offset
          if (!currentSlide) {
            currentSlide = currentHooked.element.getElementsByClassName("active")[0];
          } else {
            const currentSlideContent = currentSlide.getElementsByClassName("content-container")[0];
            const currentSlideContentInner = currentSlide.getElementsByClassName("scrollable-section")?.length > 0 ? currentSlide.getElementsByClassName("scrollable-section")[0] : currentSlide.getElementsByClassName("inner")[0];
            let switchSlides = false;

            // check scroll position of content within a slide. 
            //We don't want to transition slide down unless the user has scrolled to the bottom of the content, and don't want to transition up unless the user is scrolled to the top
            let scrolledToBottomOfSlide = currentSlideContent.offsetHeight + currentSlideContent.scrollTop >= currentSlideContent.scrollHeight;
            let scrolledToBottomOfSlideContent = currentSlideContentInner.offsetHeight + currentSlideContentInner.scrollTop >= currentSlideContentInner.scrollHeight;
            let scrolledToTopOfSlide = currentSlideContent.scrollTop <= 0;
            let scrolledToTopOfSlideContent = currentSlideContentInner.scrollTop <= 0;
            if (scrollDelta > 0) {
              // checking a scroll has occurred
              // scrolling down the slides
              if (currentSlide.classList.contains("title-slide")) {
                // allows instant scrolling from within the title slide
                currentOffset += 4;
                switchSlides = true;
              } else if (scrolledToBottomOfSlide === true && scrolledToBottomOfSlideContent === true) {
                // only scroll down a slide if we're at the bottom of the content
                switchSlides = true;
              }
              // increase offset value to signify a scroll down
              currentOffset += 1;
            } else {
              // scrolling up the slides
              if (currentSlide.classList.contains("title-slide")) {
                // allows instant scrolling from within the title slide
                currentOffset -= 4;
                switchSlides = true;
              }
              if (scrolledToTopOfSlide === true && scrolledToTopOfSlideContent === true) {
                // only scroll up a slide if we're at the top of the content
                switchSlides = true;
              }
              // decrease offset value to signify a scroll up
              currentOffset -= 1;
            }

            // if the current slide offset is at max either activate the next slide, or deactivate the current slide set if at the end
            if ((currentOffset >= slideScrollBuffer || currentOffset <= 0) && switchSlides === true) {
              const allCurrentSlides = currentHooked.element.getElementsByClassName("slide");
              let activeIndex = null;
              for (let i = 0; i < allCurrentSlides.length; i++) {
                // check the active slide, and update the activeIndex accordingly
                if (allCurrentSlides[i].classList.contains("active")) {
                  activeIndex = i;
                  i = allCurrentSlides.length;
                }
              }
              if (currentOffset >= slideScrollBuffer) {
                // if user has scrolled down enough to trigger a change in slide

                currentOffset = 0; // current scroll-offset within a slide

                // if another slide exists in the set, scroll down to it
                if (activeIndex + 1 < allCurrentSlides.length && scrolledToBottomOfSlide === true && scrolledToBottomOfSlideContent === true) {
                  // update active slide, and nav buttons to new slide
                  allCurrentSlides[activeIndex].classList.remove("active");
                  allCurrentSlides[activeIndex + 1].classList.add("active");
                  currentSlide = allCurrentSlides[activeIndex + 1];
                  updateNavButtons(getCorrespondingNavButton(activeIndex + 1));

                  // reset content scroll checks so they don't interfere with new slide
                  scrolledToBottomOfSlide, scrolledToBottomOfSlideContent, scrolledToTopOfSlide, scrolledToTopOfSlideContent = false;

                  // after scroll, pause slides for a moment
                  pauseSlides();
                } else if (scrolledToBottomOfSlide === true && scrolledToBottomOfSlideContent === true) {
                  // if no slides exist in the set, unhook and let user scroll down the remainder of the page

                  pauseSlides();

                  // scroll down & out of the scrollInPlace component
                  currentHooked.element.classList.remove("active");
                  document.body.style.overflow = "visible";
                  currentHooked = null;
                }
              } else if (currentOffset <= 0) {
                // check scroll direction is up
                // scrolling up the slides, ensure user has scrolled to the top of the content before switching
                currentOffset = slideScrollBuffer;
                if (activeIndex > 0 && scrolledToTopOfSlide === true && scrolledToTopOfSlideContent === true) {
                  // scroll up a slide in the set, update navbuttons
                  allCurrentSlides[activeIndex].classList.remove("active");
                  allCurrentSlides[activeIndex - 1].classList.add("active");
                  currentSlide = allCurrentSlides[activeIndex - 1];
                  updateNavButtons(getCorrespondingNavButton(activeIndex - 1));

                  // reset slide checks
                  scrolledToBottomOfSlide, scrolledToBottomOfSlideContent, scrolledToTopOfSlide, scrolledToTopOfSlideContent = false;
                  pauseSlides();
                } else if (scrolledToTopOfSlide === true && scrolledToTopOfSlideContent === true) {
                  // if no more slides exist above, exit the slide set and let the user continue scrolling up the page
                  pauseSlides();
                  currentHooked.element.classList.remove("active");
                  document.body.style.overflow = "visible";
                  currentHooked.element.scrollIntoView(true);
                  currentHooked = null;
                }
              }
            }
          }
        }
        lastWheel = currentWheel;
      });
    }
  }, []);
  const renderSlideBackgroundImage = slide => {
    const slideImage = slide?.image || slide?.backgroundImage;
    if (slideImage?.type === 'lottieAnimation') {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "background-image-container",
        tabIndex: 0
      }, /*#__PURE__*/_react.default.createElement(_LottieAnimation.default, {
        src: slideImage.src,
        style: slideImage.style,
        ratio: {
          width: 16,
          height: 9
        }
      }));
    } else if (slideImage?.src && !slide?.video) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "background-image-container",
        tabIndex: 0
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: slideImage.src,
        alt: slideImage.alt
      }));
    }
  };
  const renderComponentBody = () => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, titleBackground?.video && /*#__PURE__*/_react.default.createElement("div", {
      className: "background-video-container",
      tabIndex: 0
    }, /*#__PURE__*/_react.default.createElement("video", {
      width: "100%",
      height: "100%",
      autoPlay: "autoplay",
      muted: true,
      loop: true
    }, /*#__PURE__*/_react.default.createElement("source", {
      src: titleBackground?.video,
      type: "video/mp4"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "slide title-slide active",
      "data-slide-index": 0
    }, renderSlideBackgroundImage(titleBackground), /*#__PURE__*/_react.default.createElement("div", {
      className: "content-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "inner",
      tabIndex: 0
    }, /*#__PURE__*/_react.default.createElement(TitleContent, null)))), slides?.length && slides.map((slide, index) => {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "slide",
        "data-slide-index": index + 1,
        key: `slide-${index}`
      }, slide?.backgroundImage?.src && !titleBackground?.video && renderSlideBackgroundImage(slide), /*#__PURE__*/_react.default.createElement("div", {
        className: "content-container",
        tabIndex: 0
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "inner"
      }, slide?.content && /*#__PURE__*/_react.default.createElement(slide.content, null))));
    }), slides?.length && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "progress-nav"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "btns-container"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "nav-btn btn-active",
      "data-slide-index": 0,
      "data-button-type": "progress-nav",
      tabIndex: 0
    }), slides.map((slide, index) => {
      return /*#__PURE__*/_react.default.createElement("button", {
        key: `button-${index}`,
        className: "nav-btn",
        "data-slide-index": index + 1,
        "data-button-type": "progress-nav",
        tabIndex: 0
      });
    })))));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: `${isA11yMode ? "scroll-in-place-container--accessibility-mode" : "scroll-in-place-container"} ${titleBackground?.video ? "has-bg-video" : ""}`
  }, renderComponentBody()), /*#__PURE__*/_react.default.createElement("div", {
    className: "active-spacer"
  }));
};
var _default = ScrollInPlace;
exports.default = _default;